import some from "lodash/some";
import { SelectV2 } from "PFComponents/select_v2";
import { Tooltip } from "PFComponents/tooltip";
import { NotificationGroupType } from "PFCore/types";
import { Option } from "PFTypes/options";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useNotificationsPanelContext } from "../contexts/notifications_panel_context";
import { useAvailableGroupingOptions } from "../hooks/use_available_grouping_options";

type GroupBySelectProps = {
  disabled?: boolean;
};

export const GroupBySelect = ({ disabled }: GroupBySelectProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "notifications.filters" });
  const { engagement, role, categories, groupBy, setGroupBy } = useNotificationsPanelContext();

  const groupByOptions = useAvailableGroupingOptions();

  useEffect(() => {
    if (!groupByOptions.some(({ id }) => id === groupBy)) {
      setGroupBy(NotificationGroupType.None);
    }
  }, [groupByOptions]);

  const noGroupingOptions = !some(groupByOptions, ({ id }) => id !== NotificationGroupType.None);
  const showApplyFilterTooltip = noGroupingOptions && !engagement && !role && !categories.length;

  return (
    <Tooltip disabled={!showApplyFilterTooltip} content={t("applyFilterToUseGrouping")} offset={-16}>
      <SelectV2<NotificationGroupType>
        label={t("groupByLabel")}
        value={groupBy}
        options={groupByOptions}
        onChange={({ original }: Option<NotificationGroupType>) => setGroupBy(original)}
        multiple={false}
        disabled={disabled || noGroupingOptions}
      />
    </Tooltip>
  );
};
